import React, { useState } from "react";
import { Typography } from "antd";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/UseLanguage";
import { useConnectedSources } from "./Hooks/UseConnectedSources";
import { useSourceTokenSession } from "./Hooks/UseSourceTokenSession";
import { BASE_SOURCES, ODOO_SOURCE, SOURCE_ID_TO_NAME_MAP } from "./Utils/SourceConstants";
import { getEnvironmentId } from "./Utils/SourceEnvironment";

const { Title, Paragraph } = Typography;

const SourceConnectorPage: React.FC = () => {
  const [clickedSources, setClickedSources] = useState<string[]>([]);
  const { t } = useTranslation();
  useLanguage();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  const environmentId = getEnvironmentId(token, params);
  const sources = environmentId === "demo" ? [...BASE_SOURCES, ODOO_SOURCE] : BASE_SOURCES;

  useSourceTokenSession(token, true);
  const { connectedSources } = useConnectedSources(SOURCE_ID_TO_NAME_MAP);

  const handleCardClick = (source: string) => {
    if (!connectedSources.includes(source)) {
      setClickedSources(prev => [...prev, source]);
    }
  };

  return (
    <div className="connected-sources-container">
      <div className="connected-sources-content">
        <div className="source-connector-header">
          <Title level={2} className="connect-header">
            {t("sourceConnectorNew.title")}
          </Title>
        </div>
        <Paragraph className="sub-heading">{t("sourceConnectorNew.subtitle")}</Paragraph>

        <div className="cards-grid">
          {sources.map(({ name, icon, className }) => {
            const connected = connectedSources.includes(name);
            const clicked = clickedSources.includes(name);
            const cardClass = `connected-card ${className} ${connected ? "highlight-border" : ""}`;

            return (
              <Tippy
                key={name}
                content={
                  connected
                    ? t("sourceConnectorNew.connected")
                    : t("sourceConnectorNew.disconnected")
                }
              >
                <div
                  className={cardClass}
                  onClick={() => handleCardClick(name)}
                  style={{ cursor: connected ? "default" : "pointer" }}
                >
                  {!clicked ? (
                    <img src={icon} alt={`${name} Logo`} className={`connector-img-${className}`} />
                  ) : (
                    <div className="disconnected-message">
                      <span>
                        <b>{t("sourceConnectorNew.contactUs")}</b>{" "}
                        {t("sourceConnectorNew.contactUsSuffix")}
                      </span>
                    </div>
                  )}
                </div>
              </Tippy>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SourceConnectorPage;
